import React, { useState } from 'react';
import './LocationPermission.css';
import LoadingScreen from './LoadingScreen';
import { useLanguage } from './i18n/LanguageContext';

const LocationPermission = ({ onAllowAccess }) => {
  const { t } = useLanguage();
  const [isLoading, setIsLoading] = useState(false);
  const asset = (file) => `${process.env.PUBLIC_URL || ''}/images/${file}`;

  const handleAllowAccess = () => {
    setIsLoading(true);

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setTimeout(() => {
            setIsLoading(false);
            onAllowAccess(latitude, longitude);
          }, 2500);
        },
        () => {
          setTimeout(() => {
            setIsLoading(false);
            onAllowAccess(null, null);
          }, 2500);
        }
      );
    } else {
      setTimeout(() => {
        setIsLoading(false);
        onAllowAccess(null, null);
      }, 2500);
    }
  };

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <div className="location-permission-screen">
      <div className="location-permission-left" aria-hidden="true">
        <svg className="location-arcs" viewBox="0 0 1194 834" preserveAspectRatio="xMinYMid meet" fill="none">
          <defs>
            <path id="location-arc-outer" d="M 170,790 A 500,500 0 0 0 470,30" />
            <path id="location-arc-inner" d="M 130,710 A 400,400 0 0 0 390,100" />
          </defs>
          <text className="location-arc-text location-arc-text-outer">
            <textPath href="#location-arc-outer" xlinkHref="#location-arc-outer" side="right" textLength="980" lengthAdjust="spacing">
              Airport Transfers - Fixed-price rides to and from stays and airports.
            </textPath>
          </text>
          <text className="location-arc-text location-arc-text-inner">
            <textPath href="#location-arc-inner" xlinkHref="#location-arc-inner" side="right" textLength="860" lengthAdjust="spacing">
              Airport Transfers - Fixed-price rides to and from stays and airports.
            </textPath>
          </text>
          <image
            href={asset('location-arc-end.svg')}
            x="330"
            y="455"
            width="70"
            height="74"
            transform="rotate(-32 335 467)"
            opacity="0.24"
          />
        </svg>
        <div className="location-car-frame">
          <img className="location-car" src={asset('location-car.png')} alt="" />
        </div>
      </div>

      <div className="location-permission-right">
        <div className="location-icon-container">
          <div className="location-icon-circle">
            <img
              className="location-pin"
              src={asset('location-pin.svg')}
              alt=""
              width="40.1724"
              height="40.1724"
            />
          </div>
        </div>

        <h1 className="location-heading">{t('Location access')}</h1>

        <p className="location-description">
          {t('We need your location to identify your hotel and find the nearest pickup point.')}
        </p>

        <button type="button" className="allow-access-btn" onClick={handleAllowAccess}>
          <span className="allow-access-text">{t('Allow access')}</span>
        </button>
      </div>
    </div>
  );
};

export default LocationPermission;
